import { allAgeGrpFieldsNames, ANNUAL_COVER_VALUE, FAMILY_GROUP_TYPE_VALUE, } from '../../constants';
import { isDateValid, onAnnualPlanDeselect, onAnnualPlanSelect, } from '../shared';
import { removeLocalItem, setLocalItem, } from '../store/localStore';
import { generateMoreFields, displayAgeFields, } from '../ui/components/ageType';
import { dateDiffInDays, getFromQueryOrLocalStorage, getStartDatePlusOneYear, getThreeMonthsFromNow, } from '../../utils';
export function populateFromQueryParamsOrLocalStorage(form, startPicker, endPicker) {
    coverType(form);
    destination(form);
    DatePicker(form, startPicker, endPicker);
    modeTypePolicy(form);
    ageGroup(form);
}
function DatePicker(form, startPicker, endPicker) {
    const now = new Date();
    const oneYearFromNow = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate() - 1);
    const storedStartDate = getFromQueryOrLocalStorage('startDate');
    const storedEndDate = getFromQueryOrLocalStorage('endDate');
    const numberOfTripDays = getFromQueryOrLocalStorage('numberOfTripDays');
    const storedCoverType = getFromQueryOrLocalStorage('coverType');
    const threeMonthsFromNow = getThreeMonthsFromNow();
    const startDateInput = document.getElementById('start-date');
    const startDateContainer = document.querySelector('.start-date__container');
    const endDateContainer = document.querySelector('.end-date__container');
    const endDateInput = document.getElementById('end-date');
    const isAnnualCover = storedCoverType === ANNUAL_COVER_VALUE;
    if (numberOfTripDays) {
        form.set('numberOfTripDays', numberOfTripDays);
    }
    if (startDateInput &&
        storedStartDate &&
        isDateValid(storedStartDate) &&
        startPicker) {
        startDateInput.value = storedStartDate;
        form.set('startDate', storedStartDate);
        startDateContainer.classList.add('selected');
        startPicker.update({
            minDate: now,
            maxDate: isAnnualCover ? threeMonthsFromNow : oneYearFromNow,
            autoClose: false,
        });
        const today = new Date().toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
        const isOverThreeMonths = dateDiffInDays(today, storedStartDate) > 88;
        if (isAnnualCover && isOverThreeMonths) {
            startDateInput.value = '';
            setLocalItem('startDate', '');
            form.set('startDate', '');
        }
        else {
            const [day, month, year] = storedStartDate.split('/');
            const validDate = new Date(year, month - 1, day, 0, 0, 0);
            startPicker.selectDate(validDate, {
                silent: true,
            });
        }
    }
    if (endDateInput &&
        storedEndDate &&
        isDateValid(storedEndDate) &&
        storedCoverType != 'MT_MT_N' &&
        endPicker) {
        endDateInput.value = storedEndDate;
        form.set('endDate', storedEndDate);
        endDateContainer.classList.add('selected');
        const [day, month, year] = storedEndDate.split('/');
        const validDate = new Date(year, month - 1, day, 0, 0, 0);
        const [sday, smonth, syear] = storedStartDate.split('/');
        const startValidDate = new Date(syear, smonth - 1, sday, 0, 0, 0);
        endPicker.update({
            minDate: startValidDate,
            maxDate: getFromQueryOrLocalStorage('startDate')
                ? getStartDatePlusOneYear(getFromQueryOrLocalStorage('startDate'))
                : oneYearFromNow,
        });
        endPicker.selectDate(validDate, {
            silent: true,
        });
    }
}
function destination(form) {
    const destinationTypeCards = document.querySelectorAll('.qq__card.destination-type');
    const storedDestinationType = getFromQueryOrLocalStorage('area');
    if (storedDestinationType) {
        destinationTypeCards.forEach((card) => {
            const inputElement = card.querySelector('input[type="radio"]');
            if (inputElement && inputElement.value === storedDestinationType) {
                card.classList.add('active-card');
                form.set('area', storedDestinationType);
            }
        });
    }
}
function coverType(form) {
    const coverTypeCards = document.querySelectorAll('.qq__card.cover-type');
    const storedCoverType = getFromQueryOrLocalStorage('coverType');
    if (storedCoverType) {
        coverTypeCards.forEach((card) => {
            const inputElement = card.querySelector('input[type="radio"]');
            if (inputElement && inputElement.value === storedCoverType) {
                card.classList.add('active-card');
                form.set('coverType', storedCoverType);
                if (storedCoverType === 'MT_MT_N') {
                    onAnnualPlanSelect();
                }
                else {
                    onAnnualPlanDeselect();
                }
            }
        });
    }
}
function modeTypePolicy(form) {
    const modeTypeCards = document.querySelectorAll('.qq__card.mode-type');
    const storedModeType = getFromQueryOrLocalStorage('groupType');
    if (storedModeType) {
        // !!! START HERE
        // !!! REMOVE THIS CODE ONCE THE VARIANT WON
        if (storedModeType === FAMILY_GROUP_TYPE_VALUE) {
            const below18Age = document.querySelectorAll('.infant-package');
            if (below18Age.length > 0) {
                below18Age.forEach((childpkg) => {
                    childpkg.classList.remove('hidden');
                });
            }
        }
        // !!! END HERE
        displayAgeFields(form, storedModeType);
        modeTypeCards.forEach((card) => {
            const inputElement = card.querySelector('input[type="radio"]');
            if (inputElement && inputElement.value === storedModeType) {
                card.classList.add('active-card');
                form.set('groupType', storedModeType);
            }
        });
    }
}
export function ageGroup(form) {
    const modeType = getFromQueryOrLocalStorage('groupType');
    if (modeType) {
        displayAgeFields(form, modeType);
    }
    if (!modeType) {
        allAgeGrpFieldsNames.forEach((field) => {
            // TODOAB
            removeLocalItem(field);
        });
        return;
    }
    const ageFields = document.querySelectorAll('.age-groups__input');
    const ageGrpValuePair = allAgeGrpFieldsNames.reduce((acc, curr) => {
        const value = getFromQueryOrLocalStorage(curr);
        if (value) {
            acc[curr] = parseInt(value, 10);
        }
        return acc;
    }, {});
    // Check the number of keys in the object
    let cachedValuesCount = Object.keys(ageGrpValuePair).length;
    const cachedValues = Object.values(ageGrpValuePair);
    while (ageFields.length < cachedValuesCount) {
        generateMoreFields(form);
        cachedValuesCount--;
    }
    const newAgeGroups = document.querySelectorAll('.age-groups__input');
    if (newAgeGroups.length == cachedValues.length) {
        newAgeGroups.forEach((field, index) => {
            field.value = cachedValues[index].toString();
            form.set(field.id, cachedValues[index]);
        });
    }
}
